import React from 'react';
import { Laptop, Users, BookOpen } from 'lucide-react';
import Card3D from './ui/Card3D';
import SectionBackground from './ui/SectionBackground';
import { colors } from '../styles/theme';

const projects = [
  {
    icon: <Laptop className="w-8 h-8" />,
    title: "Accès au Numérique",
    description: "Distribution de serveurs privés virtuels et formation aux outils numériques essentiels pour les étudiants en difficulté.",
    stats: "200+ étudiants équipés"
  },
  {
    icon: <Users className="w-8 h-8" />,
    title: "Mentorat Digital",
    description: "Programme de mentorat connectant les étudiants avec des professionnels du numérique pour un accompagnement personnalisé.",
    stats: "10+ mentors actifs"
  },
  {
    icon: <BookOpen className="w-8 h-8" />,
    title: "Ressources Éducatives",
    description: "Plateforme de ressources pédagogiques en ligne gratuite pour développer les compétences numériques.",
    stats: "20+ ressources disponibles"
  }
];

const Projects: React.FC = () => {
  return (
    <section className="relative py-20 bg-white">
      <SectionBackground variant="left" color={colors.accent1} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Projets</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des initiatives concrètes pour réduire la fracture numérique et favoriser la réussite étudiante.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {projects.map((project, index) => (
            <Card3D key={index}>
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 text-[#0139B7] group-hover:bg-[#0139B7] group-hover:text-white transition-colors">
                  {project.icon}
                </div>
                <h3 className="text-xl font-bold mb-4">{project.title}</h3>
                <p className="text-gray-600 mb-6">{project.description}</p>
                <div className="text-[#0139B7] font-semibold">{project.stats}</div>
              </div>
            </Card3D>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;